export * from '@platform/components/fullscreen/fullscreen.component';
export * from '@platform/components/fullscreen/fullscreen.types';
